/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { observer } from 'mobx-react';
import React from 'react';
import { defineMessages } from 'react-intl';
import { LuisText, LuisTextProps } from 'src/core/components/LuisText';
import { Page } from 'src/core/components/Page';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { getStylist } from 'src/core/themes/luisStylist';

const messages = defineMessages({
    pageTitle: {
        id: 'portal.maintenancePage.pageTitle',
        defaultMessage: "We'll be back soon!"
    },
    pageMessage: {
        id: 'portal.maintenancePage.pageMessage',
        defaultMessage: "Sorry for the inconvenience but we're performing some maintenance at the moment."
    }
});

const { styleComponent } = getStylist('MaintenancePage');
const CenteredText = styleComponent<LuisTextProps>(LuisText)('CenteredText', { textAlign: 'center', paddingBottom: '20px' });

/**
 * Renders a simple page to be displayed in maintenance mode.
 */
export const MaintenancePage = observer(() => {
    const { localize } = useLocalization();

    return (
        <Page pageName="MaintenancePage" size="container" title={localize(messages.pageTitle)}>
            <CenteredText variant="xxLargePlus" as="h1" data-automation-id="title">
                {localize(messages.pageTitle)}
            </CenteredText>
            <CenteredText variant="xLargePlus" data-automation-id="message">
                {localize(messages.pageMessage)}
            </CenteredText>
        </Page>
    );
});
